import React from "react";

// Widget wrappers
import MatchListing from "./common/liveCenter/matchListing/MatchListing";

// Utils
import { ColorVariables } from "../utils/general";
import RugbyMatchWidgetWrap from "./widgetBoxes/rugby/RugbyMatchWidgetWrap";
import RugbyLeagueWidgetWrap from "./widgetBoxes/rugby/RugbyLeagueWidgetWrap";
import RugbyTeamWidgetWrap from "./widgetBoxes/rugby/RugbyTeamWidgetWrap";

const RugbyWidgets = ({
    dataId,
    dataType,
    sport,
    difference,
    head,
    data,
    headData,
    baseUrl,
    loadCSS,
    setDataId,
    setDataType,
    setHead,
    setDate,
    date,
    setIsLive,
    isLive,
    dataClient = false,
    websiteBaseUrl,
    dataPath,
    dataTitle,
}) => {
    const props = {
        dataId,
        dataType,
        sport,
        difference,
        head,
        data,
        headData,
        baseUrl,
        loadCSS,
        setDataId,
        setDataType,
        setHead,
        setDate,
        date,
        setIsLive,
        isLive,
        dataClient,
        websiteBaseUrl,
        dataPath,
        dataTitle,
    };;

    // Only run on client
    React.useEffect(() => {
        const loadSettings = async () => {
            try {
                const res = await fetch(`${baseUrl}/settings`, {
                    headers: {
                        Token: process.env.REACT_APP_SETTINGS_TOKEN,
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                });

                if (!res.ok) throw new Error(res.statusText);

                const settings = await res.json();
                const cssVars = ColorVariables(settings);

                const styleTag = document.createElement("style");
                styleTag.textContent = cssVars;
                document.head.appendChild(styleTag);

                document.querySelectorAll(".microservice-cont")?.forEach((el) => el?.classList.add("hydrated"));


                // Cleanup in React.StrictMode / HMR
                return () => {
                    if (document.head.contains(styleTag)) {
                        document.head.removeChild(styleTag);
                    }
                };
            } catch (err) {
                console.error("⚠️ Failed to load dynamic CSS settings:", err);
            }
        };

        loadSettings();
    }, [baseUrl]);


    if (dataType?.startsWith("rugby-match")) {
        return <RugbyMatchWidgetWrap {...props} channel="RugbyMatch"
            event={`RugbyMatchDetails-${dataId}`} />;
    }

    if (dataType?.startsWith("rugby-league-")) {
        return <RugbyLeagueWidgetWrap {...props} />;
    }

    if (dataType?.startsWith("rugby-team-")) {
        return <RugbyTeamWidgetWrap {...props} />;
    }

    if (dataType === "live-match-detail" || dataType === "live-centre") {
        return (
            <MatchListing
                sport={sport}
                data={data?.data}
                difference={difference}
                matchType="all"
                loadCSS={loadCSS}
                baseUrl={baseUrl}
                dataType={dataType}
                setDataType={setDataType}
                setDataId={setDataId}
                setHead={setHead}
                setDate={setDate}
                date={date}
                setIsLive={setIsLive}
                isLive={isLive}
                dataClient={dataClient}
                websiteBaseUrl={websiteBaseUrl}
                dataPath={dataPath}
                socketUrl={process.env.REACT_APP_SOCKET || 'https://socket-bolsaas.6lgx.com/'}
            />
        );
    }

    return <h1>⚠️ Widget Not Found in Rugby!</h1>;
};

export default RugbyWidgets;
